// ============================================================
// HOOKS DE VALIDACIÓN – SALVIR
// ============================================================
//
// Este archivo centraliza los hooks de validación
// que requieren estado o efectos de React.
//
// NOTA: las funciones puras viven en sus respectivos
// archivos (identidad.js, expediente.js, etc.)
// ============================================================

import { useState, useEffect } from "react";
import { getMedicoAuth, validarCluesCatalogo } from "../../services/usuarios";
import { verificarPerfilPrestador } from "./identidad";

// ============================================================
// useVerificarPerfil
// ------------------------------------------------------------
// Verifica si el médico autenticado tiene el perfil completo
// para poder iniciar consultas.
//
// NOTA: cuando agregues el switch NOM-024, aquí condicionas
// la verificación a que el switch esté prendido.
// ============================================================
export const useVerificarPerfil = () => {
  const [faltantes, setFaltantes] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const cargar = async () => {
      const medico = await getMedicoAuth();

      let establecimientoCatalogo = null;
      const clues = medico?.perfil?.clues;

      if (clues) {
        establecimientoCatalogo = await validarCluesCatalogo(clues);
      }

      const resultado = verificarPerfilPrestador(medico, establecimientoCatalogo);
      setFaltantes(resultado);
      setCargando(false);
    };
    cargar();
  }, []);

  return { faltantes, cargando };
};